<messages></messages>
<add-content></add-content>
<header>
	<soinu-progress *ngIf="!isMap"></soinu-progress>
</header>



<section *ngIf="!isMap">
	<nav class="language" style="">
		<ul *ngIf="localeId=='es'">
			<li><a href="/eu/">EU</a></li>
			<li><b>ES</b></li>
		</ul>
		<ul *ngIf="localeId=='eu'">
			<li><b>EU</b></li>
			<li><a href="/es/">ES</a></li>
		</ul>
	</nav>
	<h1 i18n="Titulo">Construir a través del oído</h1>
	<p i18n="Texto intro">El objetivo del proyecto sonoro realizado por la asociación AUDIOLAB dentro del programa de arte y ruralidad de la Dirección General-Institución Príncipe de Viana Landarte 2018 es sensibilizar a los vecinos de Sartaguda sobre la importancia de la escucha. El resultado del mismo se puede consultar de formas diversas: A través de un mapa sonoro interactivo, escuchando el programa de radio realizado colectivamente o realizando los ejercicios del cuaderno pedagógico. En definitiva, la propuesta de los artistas sonoros Xabier Erkizia y Luca Rullo pretende ser una excusa para repensar la escucha y por qué no, construir nuevas formas de comprender la realidad a través del oído.</p>
	<p><audio style="width:100%;" src="https://archive.org/download/SARTAgudaRadio/SARTAguda_radio.mp3" controls></audio></p>
	<nav *ngIf="appService.acceptCookies">
		<button i18n="Mapa" pButton label="map" (click)="showMap()" title="Muestra el mapa">Mapa</button>
		<button i18n="Radio" pButton label="listen" (click)="listenStream()" title="En directo">Radio</button>
		<button i18n="Cuaderno" pButton label="listen" (click)="openPDF('assets/SARTAGUDA_entzun_escucha.pdf')" title="Cuaderno">Pequeño cuaderno de escucha</button>
		<button i18n="Soinumapa" pButton label="listen" (click)="openSoinumapa()" title="Participa">Participa</button>
	</nav>
	<footer>
		<ul>
			<li><img alt="Landarte" title="Landarte" src="assets/landarte.png"/></li>
			<li><img alt="Gobierno de Navarra" title="Gobierno de Navarra" src="assets/gobierno_navarra_logo.png"/></li>
			<li><img alt="Ayuntamiento de Sartaguda" title="Ayuntamiento de Sartaguda" src="assets/sartaguda.png"/></li>
			<li><img alt="Audiolab" title="Audiolab" src="assets/audio-lab_logo.png"/></li>
			<li><img alt="Red Tramontana" title="Red Tramontana"style="min-width:50px;min-height:50px;" src="assets/tramontana.png"/></li>
		</ul>
	</footer>
</section>
<map-box *ngIf="isMap"></map-box>



// WEBPACK FOOTER //
// ./src/app/app.component.html